var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminApiToggleActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1502"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color l Track",
    y: 2,
    width: 34,
    height: 14,
    rx: 7,
    fill: "var(--fill-0, #009BE5)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Color l Thumb",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20C29.5228 20 34 15.5228 34 10C34 4.47715 29.5228 0 24 0C18.4772 0 14 4.47715 14 10C14 15.5228 18.4772 20 24 20Z",
    fill: "var(--fill-0, #009BE5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminApiToggleActiveIcon);
export default __webpack_public_path__ + "static/media/AdminApiToggleActiveIcon.34078c4c6997a606e65b121b25681ef1.svg";
export { ForwardRef as ReactComponent };